import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { showDialog, DeskPhonesDialog } from '@zoom/fe-billing-components';
import pcm from '@/global-install/global-pcm';
import { hideModalDialogCloseButton, showModalDialogCloseButton } from '@/utils/modal-utils';
import { ZOOM_DEVICE_TYPE_MAP } from './helper';
import { planTypes } from '@/common/constants';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';
import { ZOOM_DEVICE_CATEGORY } from './constant';
import _ from 'lodash';
import softBundlePlanMixin from '@/views/config/soft-bundle/mixin/soft-bundle-plan';

export default {
  mixins: [softBundlePlanMixin],
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      allPlanMap: state => state.ShoppingCart.allPlanMap
    }),
    ...mapGetters(['getSelectedPlans', 'isExistSoftBundleConfig']),
    mx_isLegacyModalUI() {
      return this.$context?.is?.modal && !this.$context?.is?.modal2Column;
    },
    mx_devicePlanList() {
      return this.planMapFlat.filter((p) => p.isVendorProduct);
    },
    mx_currentSellerId() {
      return this.mx_devicePlanList[0]?.__originData?.sellerId
    },
    mx_currentVendorData() {
      return this.allPlanMap.__vendorsData?.vendors?.find(item => item.id === this.mx_currentSellerId)
    },
    mx_returnPolicy() {
      return this.mx_currentVendorData?.returnUrl
    },
    mx_privacyPolicy() {
      return this.mx_currentVendorData?.privacyUrl
    },
    mx_rmaUrl() {
      return this.mx_currentVendorData?.rmaUrl
    },
    mx_helpUrl() {
      return this.mx_currentVendorData?.helpUrl
    },
    mx_zoomDeviceDialogProducts() {
      return this.mx_devicePlanList.map(item => {
        const quantity = item.cartInfo.selected_number;

        return {
          ...item.__originData,
          _disabled: !!quantity,
          _selected: !!quantity
        }
      })
    },
    mx_soft_bundle_zoom_device_planTypeList() {
      return _.filter(this.soft_bundle_config_planTypeList, item => _.startsWith(item, planTypes.ZOOM_DEVICE));
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    ...mapActions(['switchSelectPlanAction']),
    openZoomDeviceDialog(planType = planTypes.ZOOM_DEVICE$DESK_PHONE) {
      // for soft bundle case
      if (this.isExistSoftBundleConfig) {
        const devicePlanTypeList = this.mx_soft_bundle_zoom_device_planTypeList;
        if (devicePlanTypeList.length === 1 && _.includes(devicePlanTypeList, planType)) {
          this.mx_openZoomDeviceDialog({ allowCategorySwitch: false, planType  });
          return;
        }
      }

      this.mx_openZoomDeviceDialog({ planType });
    },
    async mx_openZoomDeviceDialog({
      allowCategorySwitch = true,
      planType = planTypes.ZOOM_DEVICE$DESK_PHONE
    }) {
      const category = ZOOM_DEVICE_CATEGORY[planType];

      const planName = this.mx_zoomDeviceDialogProducts.find(item => item._disabled)?.name;
      if (planName) {
        this.$tracking.buyInteraction('add another phone model', `zoom device - ${planName} - add another phone model`);
      } else {
        this.$tracking.buyInteraction('add another phone model', `zoom device - view phones`);
      }

      hideModalDialogCloseButton()
      return new Promise((resolve) => {
        // const loading = this.$loading()
        showDialog(pcm, DeskPhonesDialog, {
          visible: true,
          loading: false,
          returnPolicy: this.mx_returnPolicy,
          privacyPolicy: this.mx_privacyPolicy,
          products: this.mx_zoomDeviceDialogProducts,
          allowCategorySwitch: allowCategorySwitch,
          category: category,
          cardLayout: this.mx_isLegacyModalUI ? 'vertical' : 'horizontal',
        }, {
          onAddToCart: (data) => {
            this.__handleAddNewOne(data)

            const type = ZOOM_DEVICE_TYPE_MAP[data.category]?.type
            if (planTypes[type]) {
              this.$emit('add', planTypes[type])
            }
            resolve(data)
          },
          onClose: () => {
            showModalDialogCloseButton()
          }
        })
        // loading.close()
      })
    },
    __handleAddNewOne(data) {
      const { items } = data

      this.updateSelectPlan({
        plan_code: `${items[0].itemMarketId}`,
        cartInfo: { selected_number: 1 },
      });
    },
    async mx_openZoomDeviceSwitchDialog(planType, currentPlan) {
      const category = ZOOM_DEVICE_CATEGORY[planType];
      const productList = _.filter(this.mx_zoomDeviceDialogProducts, item => item?.category === category);
      const planKey = planTypes[planType];
      const deviceName = getTrackingProductNameByPlanType(planKey) || 'zoom device';

      // switch device models
      if (currentPlan) {
        this.$tracking.buyInteraction(
          `${deviceName} options`,
           `${deviceName} - ${currentPlan?.planName} - switch phone model`
        );
      } else {
        this.$tracking.buyInteraction(
          `${deviceName} options`,
          `${deviceName} - view phone models`
        );
      }

      hideModalDialogCloseButton()
      return new Promise((resolve) => {
        showDialog(pcm, DeskPhonesDialog, {
          visible: true,
          loading: false,
          returnPolicy: this.mx_returnPolicy,
          privacyPolicy: this.mx_privacyPolicy,
          products: productList,
          actionType: 'switch',
          allowCategorySwitch: false,
          cardLayout: this.mx_isLegacyModalUI ? 'vertical' : 'horizontal',
        }, {
          onAddToCart: (data) => {
            if (!currentPlan) return resolve(data);
            this.__handleSwitchPlan(currentPlan, data)
            resolve(data)
          },
          onClose: () => {
            showModalDialogCloseButton()
          }
        })
      })
    },
    __handleSwitchPlan(currentPlan, data) {
      const { items = [] } = data
      const currentQuantity = currentPlan?.cartInfo?.selected_number
      const newPlan = {
        plan_code: `${items[0]?.itemMarketId}`,
        cartInfo: { selected_number: currentQuantity || 1 },
      }
      this.switchSelectPlanAction([currentPlan.plan_code, newPlan]);
    }
  }
};
